export function getPreferredLanguage() {
  return localStorage.getItem("preferredLang") || "en";
}

function clearGoogleTranslateCookies() {
  const host = window.location.hostname;
  const expire =
    "googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;max-age=0";

  document.cookie = expire;

  if (host && host !== "localhost" && !/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    document.cookie = `${expire};domain=${host}`;
    document.cookie = `${expire};domain=.${host}`;
  }
}

function setGoogleTranslateCookie(cookieValue) {
  const oneYear = 31536000;
  const host = window.location.hostname;
  const baseCookie = `googtrans=${cookieValue};path=/;max-age=${oneYear}`;

  document.cookie = baseCookie;

  if (host && host !== "localhost" && !/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    document.cookie = `${baseCookie};domain=${host}`;
    document.cookie = `${baseCookie};domain=.${host}`;
  }
}

export function applyPreferredLanguage(lang) {
  const safeLang = lang === "es" ? "es" : "en";

  if (safeLang === "es") {
    setGoogleTranslateCookie("/en/es");
  } else {
    clearGoogleTranslateCookies();
  }

  localStorage.setItem("preferredLang", safeLang);

  const overlay = document.getElementById("lang-overlay");
  if (overlay) {
    overlay.style.display = "flex";
  }

  setTimeout(() => {
    window.location.reload();
  }, 250);
}
